/* istanbul ignore file */
export * from './TextWithDialog';
